import { template as template_f9d8ea51739d44e880472c342f59c25b } from "@ember/template-compiler";
export const getOptions = (previousVariableDefs, formattedVariableDefConfigValue)=>{
    if (formattedVariableDefConfigValue != null) {
        previousVariableDefs.push(formattedVariableDefConfigValue);
    }
    const groups = {};
    for (const value of previousVariableDefs){
        const stationName = value.task.parent.name;
        if (!Object.hasOwn(groups, stationName)) {
            const taskName = value.task.name;
            groups[stationName] = {
                [taskName]: [
                    value
                ]
            };
        } else {
            const taskName = value.task.name;
            if (!Object.hasOwn(groups[stationName], taskName)) {
                groups[stationName][taskName] = [
                    value
                ];
            } else {
                groups[stationName][taskName].push(value);
            }
        }
    }
    const options = [];
    for (const station of Object.keys(groups)){
        const stationData = {
            groupName: station,
            options: []
        };
        const tasks = groups[station];
        for (const task of Object.keys(tasks)){
            const taskData = {
                groupName: task,
                options: tasks[task]
            };
            stationData.options.push(taskData);
        }
        options.push(stationData);
    }
    return options;
};
export const variableValueMatcher = (value, term)=>{
    if (value.name.includes(term) || value.task.name.includes(term) || value.task.parent.name.includes(term)) {
        return 1;
    }
    return -1;
};
export const SelectedVariableValueTemplate = template_f9d8ea51739d44e880472c342f59c25b(`
<span title={{@option.task.parent.name}} class="w-100">
  {{@option.task.parent.name}} - {{@option.task.name}} - {{@option.name}}
</span>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
